import { VStack, SimpleGrid, SlideFade, useDisclosure } from '@chakra-ui/react';
import { useEffect } from 'react';
import LocationWithDistanceCard from './LocationWithDistanceCard';

export type SearchListProps = {
  input?: string;
};

// 歸還餐盒地點搜尋結果列表
export default function SearchList({ input }: SearchListProps) {
  const { isOpen, onToggle } = useDisclosure();

  useEffect(() => {
    if (input !== '' && !isOpen) {
      onToggle();
    }
  }, [input]);

  return (
    <VStack spacing={4} align="stretch">
      {input && (
        <SlideFade in={isOpen} offsetY="0px" offsetX="20px">
          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={3}>
            <LocationWithDistanceCard
              distance="距離1.5公里"
              name="靜思竹軒"
              location="走進大禮堂門口右轉"
              time="星期二 08:00-16:00"
            />
            <LocationWithDistanceCard
              distance="距離1.5公里"
              name="靜思竹軒"
              location="走進大禮堂門口右轉"
              time="星期二 08:00-16:00"
            />
            <LocationWithDistanceCard
              distance="距離1.5公里"
              name="靜思竹軒"
              location="走進大禮堂門口右轉"
              time="星期二 08:00-16:00"
            />
          </SimpleGrid>
        </SlideFade>
      )}
    </VStack>
  );
}
